import React from 'react'
import styles from './styles.module.css'

const Privacy_policy = () => {
    return (
        <div className={styles.legalPage}>
            <h2 className={styles.legalTitle}>DIGITAL PERSONAL DATA PROTECTION POLICY </h2>
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>INTRODUCTION</div>
                <div>
                    This Policy is established in compliance with the Digital Personal Data Protection Act, 2023
                    ("DPDP Act") and its subsequent Rules. Lynkit Solutions Private Limited ("Lynkit", "We", "Us")
                    acts as a Data Fiduciary for the personal data we collect. We are committed to processing
                    your data in a lawful, fair, and transparent manner.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>DATA WE COLLECT </div>
                <div>
                    We collect and process personal data necessary for providing our services. This may include
                    personal details, contact information, geolocation data, device information, technical logs, and
                    service usage information.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>SPECIFIED PURPOSES OF PROCESSING</div>
                <div>
                    We collect and process your data when you access or use our application, platform, services,
                    or any features made available through them, only to the extent necessary to provide, operate
                    and support the services availed or opted for by you, including for the following purposes:
                </div>
                <ul>
                    <li>To provide, operate and enable the application features and services availed or opted
                        for by you, including real-time fleet/vehicle tracking, shipment tracking, vehicle
                        verification, driver e-KYC, driver onboarding, and supply chain automation.</li>
                    <li>To verify the identity of drivers and authorized personnel including through KYC, e
                        KYC, document verification, or other verification processes required for use of the
                        services.</li>
                    <li>To deliver your opted goods and services at your place of business.  </li>
                    <li>To provide customer support and respond to service queries. </li>
                    <li>To ensure the security of our platform and prevent fraudulent activities.</li>
                    <li>To comply with legal obligations under Indian law (e.g., transport regulations, goods
                        movement, taxation/ compliance). </li>
                </ul>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>CONSENT AND WITHDRAWAL  </div>
                <ul>
                    <li>We process your data based on your free, specific, informed, unconditional, and
                        unambiguous consent, given through a clear affirmative action. </li>
                    <li>You may withdraw your consent at any time by contacting us or through the
                        mechanisms made available by Lynkit. Withdrawal of consent will result in
                        discontinuation of the services provided by Lynkit.</li>
                </ul>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>YOUR RIGHTS AS A DATA PRINCIPAL </div>
                <div>
                    Under the DPDP Act, you have the following enforceable rights:
                </div>
                <ul>
                    <li>Request a summary of your personal data being processed and the identities of third
                        parties with whom it has been shared.  </li>
                    <li>Request the correction of inaccurate data or the deletion of data once the purpose of
                        collection is fulfilled. </li>
                    <li>Raise concerns regarding data processing with our Grievance Officer.</li>
                    <li>Nominate any other individual to exercise your rights in the event of your death or
                        incapacity.</li>
                </ul>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>DATA SECURITY AND RETENTION </div>
                <ul>
                    <li>We implement reasonable technical and organizational security measures, including
                        encryption and access controls, to protect personal data against unauthorized access,
                        disclosure, alteration, loss, or misuse.</li>
                    <li>Personal data will be retained only for as long as necessary to fulfill the purposes
                        stated in this Policy or as required under applicable law. Upon expiry of the retention
                        period, such data will be deleted or anonymized in accordance with applicable laws
                        and internal retention policies.  </li>
                </ul>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}> THIRD-PARTY INTEGRATIONS  </div>
                <div>
                    Our services may integrate with third-party systems, platforms, APIs, or service providers
                    through which personal data may be accessed, received, or retrieved for providing the
                    services.
                </div>
                <div>
                    Lynkit will process such data in accordance with this Policy and applicable law. Lynkit shall
                    not be liable for any breach, misuse, inaccuracy, or unauthorised processing caused solely by
                    such third parties, unless attributable to Lynkit’s negligence, misconduct, or violation of law.
                </div>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}> SHARING AND TRANSFER  </div>
                <div>
                    We may share your data with third-party service providers, partners, or authorities as
                    necessary for providing our services, business operations, legal compliance, security, and
                    support purposes. Personal data will not be transferred to restricted countries as notified by
                    the Central Government of India.
                </div>

            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>GRIEVANCE REDRESSAL MECHANISM  </div>
                <div>
                    In case of any complaint or query, you may contact our designated Grievance Officer:
                </div>
                <ul>
                    <li>Name: GO </li>
                    <li>Email: compliance@lynkit.in </li>
                    <li>Address: 246, Block A, Okhla Industrial Area, Phase - I, New Delhi - 110020 </li>
                    <li>We will acknowledge grievances within a reasonable time and endeavor to resolve
                        them in accordance with applicable law.</li>
                </ul>
            </div>
            <br />
            <div >
                <div style={{ fontSize: "1.32rem", fontWeight: "500" }}>  CHANGE TO THIS POLICY  </div>
                <div>
                    We reserve the right to update or modify this Privacy Policy at any time. Any changes will be
                    effective immediately upon posting on this page.
                </div>

            </div>
            <br />
        </div>
    )
}

export default Privacy_policy